"use client";

import { ReactNode } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../shadcn";
import { AppButton } from "./app-button";
import { FigmaTypography } from "./figma-typography";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmButtonColor?: "red400" | "zinc950";
  confirmStartAdornment?: ReactNode;
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonColor = "red400",
  confirmStartAdornment
}: ConfirmationModalProps) => {
  const handleConfirm = async () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        onClick={(e) => e.stopPropagation()}
        data-testid="confirmation-modal"
        className="w-[440px] p-5 rounded-xl sm:rounded-xl border-innoveraZinc-100"
      >
        <DialogHeader className="space-y-1">
          <DialogTitle data-testid="confirmation-modal-title">
            <FigmaTypography variant="heading-3" color="zinc900">
              {title}
            </FigmaTypography>
          </DialogTitle>
          <DialogDescription data-testid="confirmation-modal-description">
            <FigmaTypography variant="body-2" color="zinc700">
              {description}
            </FigmaTypography>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:space-x-1">
          <AppButton appearance="outlined" color="zinc150" onClick={onClose} data-testid="cancel-button">
            {cancelText}
          </AppButton>
          <AppButton
            onClick={handleConfirm}
            color={confirmButtonColor}
            startAdornment={confirmStartAdornment}
            data-testid="confirm-button"
          >
            {confirmText}
          </AppButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
